export const CANVAS_HEIGHT = 500;
export const NODE_WIDTH = 300;
export const NODE_HEIGHT = 250;
export const NODE_HEIGHT_SMALL = 200;
export const EXPANDED_ACTIONS_WIDTH = 120;
export const DATA_RETRIEVER_MIN_WIDTH = 350;
// Vertical center of a BYO shell card, ignoring the footer below it — ReactFlow
// positions handles by percentage of the measured node, so pinning to this
// value keeps edges leaving from the card center instead of the card+footer.
export const HANDLE_PIN_TO_CARD_CENTER = 50;

export const entityByKey = {
  code_containers: 'transforms',
  data_maps: 'dataMaps',
  data_sinks: 'sinks',
  data_sets: 'dataSets',
  data_sources: 'dataSources',
  data_credentials: 'dataCredentials',
};

export const labelBgStyles = {
  RELATION: {
    padding: 4,
    fill: 'var(--color-success-100)',
    stroke: `var(--color-success-600)`,
  },
  DEPENDENCY: {
    padding: 4,
    fill: 'var(--color-secondary-50)',
    stroke: `var(--color-secondary-300)`,
  },
};

export const labelStyles = {
  RELATION: {
    fontSize: 12,
    lineHeight: 16,
    fill: `var(--color-success-900)`,
  },
  DEPENDENCY: {
    fontSize: 12,
    lineHeight: 16,
    fill: `var(--color-secondary-900)`,
  },
};
